import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ReferralsViewStore } from 'pages/settings/pages/referrals/store/referralsViewStore'

export const ReferralsViewContext = createContext<ReferralsViewStore | null>(null)

export const useReferralsViewContext = () => {
  const context = useContext(ReferralsViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReferralsViewContext')

  return context
}

export const ReferralsViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ReferralsViewStore(entities), [])

  useEffect(() => store.dispose, [])

  return <ReferralsViewContext.Provider value={store}>{children}</ReferralsViewContext.Provider>
}
